import { WITHDRAWAL_CHANNEL_PREFIX } from '../constants';

function createWithdrawalChannelName(id?: number) {
  return `${WITHDRAWAL_CHANNEL_PREFIX}${id}`;
}

export { createWithdrawalChannelName };
